/**
 * Copyright 2022 Design Barn Inc.
 */

import * as React from 'react';

export const FolderOutlineIcon: React.FC = (): JSX.Element => (
  <svg width="14" height="14" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M0.614014 1.99996C0.614014 1.26358 1.21097 0.666626 1.94735 0.666626H4.05909C4.52744 0.666626 4.96145 0.912358 5.20242 1.31397L5.62561 2.01929C5.86657 2.42089 6.30058 2.66663 6.76893 2.66663H11.2807C12.0171 2.66663 12.614 3.26358 12.614 3.99996V9.99996C12.614 10.7363 12.0171 11.3333 11.2807 11.3333H1.94735C1.21097 11.3333 0.614014 10.7363 0.614014 9.99996V1.99996Z"
      stroke="currentColor"
    />
  </svg>
);
